import React, { useEffect, useState } from "react";
import Layouts from "../../../components/Layouts";
import {
  Button,
  Form,
  Modal,
  Select,
  Space,
  Table,
  Tabs,
  Typography,
  Upload,
} from "antd";
import { getDirectusClient } from "../../../lib/directus";
import {
  MinusCircleOutlined,
  PlusOutlined,
  EyeOutlined,
  DeleteOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import Caja from "../components/Caja";
import Grupo from "../components/Grupo";
import Serial from "../components/Serial";
import Column from "antd/es/table/Column";
import {
  createItem,
  readItems,
  readUsers,
  updateItem,
  updateItems,
  updateUser,
} from "@directus/sdk";
import { useSelector } from "react-redux"; // Add this import
const { Title } = Typography;
const { Option } = Select;
const arraytotalproductos = [];
let deletecambio = false;

function LoanCreate(props) {
  const [vendedoresloan, setVendedoresloan] = useState([]);
  const [vendedorselect, setVendedorselect] = useState({});
  const [productoselect, setProductoselect] = useState({});
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [serialeslist, setSerialeslist] = useState([]);
  const [modalseriales, setModalseriales] = useState(false);
  const [productosagregados, setProductosagregados] = useState([]);
  const [productosagregadosver, setProductosagregadosver] = useState([]);
  const [fileList, setFileList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [total, setTotal] = useState(0); // Define total as a state variable
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const [form] = Form.useForm();

  const userBodega = useSelector((state) => state.userdata.bodega?.id); // Add userBodega selector

  const items = [
    {
      key: "1",
      label: `Por caja`,
      children: (
        <Caja
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: "2",
      label: `Por serial`,
      children: (
        <Serial
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
    {
      key: "3",
      label: `Por caja y grupo`,
      children: (
        <Grupo
          productosagregados={productosagregados}
          setProductosagregados={setProductosagregados}
        />
      ),
    },
  ];
  async function fetchProductos() {
    const directus = await getDirectusClient();
    const { data: productos } = await directus.request(
      readItems("productos", { fields: "*.*", limit: -1 })
    );
    setProductos(productos);
  }

  const getVendedoresloan = async () => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          fields: ["*.*"],
          filter: {
            role: {
              name: { _contains: "vendedor" },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
          sort: ["first_name"],
        })
      );
      setVendedoresloan(response);
    } catch (err) {
      console.error("Error fetching vendors:", err);
      Modal.error({
        title: "Error",
        content: "Error al cargar los vendedores",
      });
    }
  };

  // Update handleSearch to maintain the same filter
  const handleSearch = async (value) => {
    try {
      const directus = await getDirectusClient();
      const response = await directus.request(
        readUsers({
          search: value,
          fields: ["*.*"],
          filter: {
            role: {
              name: { _contains: "vendedor" },
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: {
                    id: { _eq: userBodega },
                  },
                }
              : {}),
          },
        })
      );
      setVendedoresloan(response);
    } catch (error) {
      console.error("Error searching vendors:", error);
    }
  };

  useEffect(() => {
    getVendedoresloan();
    fetchProductos();
  }, []);

  const onFinish = async (ev) => {
    const directus = await getDirectusClient();
    if (arraytotalproductos.length <= 0) {
      Modal.warning({
        title: "No hay seriales para prestar",
        content: "Por favor agrege seriales al prestamo e intente de nuevo",
      });
      console.log(ev);
    } else {
      try {
        console.log(ev);
        console.log(arraytotalproductos);
        let arrguardar = [];
        let arrguardarp = [];

        let arrproducto = [];

        arraytotalproductos.map((p) => {
          arrguardar.push({ id: p.id, user: "+", estado: 8 });
        });

        productosagregadosver.map((pro) => {
          arrproducto.push({ id: pro.id });
        });

        arraytotalproductos.map((p) => {
          arrguardarp.push({ id: p.id, prestamo: "+", estado: 8 });
        });

        const loanResponse = await directus.request(
          createItem("prestamos", {
            vendedor: ev.vendedor,
            tipo: "prestamo",
            seriales: {
              create: arraytotalproductos.map((producto) => ({
                prestamos_id: "+",
                seriales_id: {
                  id: producto.id,
                },
              })),
            },
            estado: "solicitud_prestamo",
          })
        );

        if (loanResponse.id) {
          await directus.request(
            createItem("historial_seriales", {
              tipo: 3,
              prestamo: loanResponse.id,
              seriales: {
                create: arraytotalproductos.map((producto) => ({
                  historial_seriales_id: "+",
                  seriales_id: {
                    id: producto.id,
                  },
                })),
              },
            })
          );
          const serialIds = arraytotalproductos.map((producto) => producto.id);
          await directus.request(
            updateItems("seriales", serialIds, {
              estado: 8,
            })
          );
          await directus.request(
            updateUser(vendedorselect.id, {
              prestamo_usado: parseFloat(
                (
                  parseFloat(vendedorselect.prestamo_usado || 0) +
                  parseFloat(total)
                ).toFixed(2)
              ),
              vendedor: ev.vendedor,
              seriales_prestados: {
                create: [],
                update: arrguardar,
                delete: [],
              },
              productos_prestados: {
                create: [],
                update: arrproducto,
                delete: [],
              },
            })
          );

          Modal.success({
            title: "Proceso exitoso",
            content: "Se realizó el préstamo correctamente",
          });

          setProductos([]);
          setModalseriales(false);
          setProductosagregados([]);
          setProductosagregadosver([]);
          arraytotalproductos.splice(0, arraytotalproductos.length);
          setVendedorselect({});
        }
      } catch (error) {
        console.error("Error creating loan:", error);
        Modal.error({
          title: "Error",
          content: "Error al crear el prestamo",
        });
      }
    }
  };

  const selecionado = (ev) => {
    console.log(vendedoresloan.find((item) => item.id === ev));
    setVendedorselect(vendedoresloan.find((item) => item.id === ev));
  };

  const selecionadoproducto = (ev) => {
    console.log(productos.find((item) => item.id === ev));
    setProductoselect(productos.find((item) => item.id === ev));
  };
  const onChange = (key) => {
    console.log(key);
  };

  useEffect(() => {
    ejecutaconversion();
  }, [productosagregados]);

  const ejecutaconversion = () => {
    let existe = 0;
    productosagregados.map((producto) => {
      producto.prestamo = "+";
      let found = arraytotalproductos.find(
        (item) => item.serial === producto.serial
      );
      if (found) {
        existe = existe + 1;
      } else {
        arraytotalproductos.push(producto);
      }
    });

    console.log(existe);
    if (!deletecambio) {
      if (existe > 0) {
        Modal.error({
          title: "Seriales existentes",
          content: `Ya existen ${existe} serial(es) de los que intenta agregar al prestamo y se a(n) omitido`,
        });
        //existe = 0;
      } else {
      }
      deletecambio = false;
    }
    const productos = arraytotalproductos.reduce((acc, obj) => {
      console.log(obj);
      const key = obj.producto.nombre;
      if (!acc[key]) {
        acc[key] = { producto: key, seriales: [], precio: 0 };
      }
      acc[key].seriales.push({ serial: obj.serial, id: obj.id });
      acc[key].precio = obj.producto.preciosinimp; // Asumiendo que el precio es de $100
      acc[key].impuesto = obj.producto.grupo.impuesto; // Asumiendo que el precio es de $100
      acc[key].id = obj.producto.id; // Asumiendo que el precio es de $100
      return acc;
    }, {});

    const productosArray = Object.values(productos);

    console.log("largo" + arraytotalproductos.length);
    if (arraytotalproductos.length <= 0) {
      setProductosagregadosver([]);
    } else {
      setProductosagregadosver(productosArray);
      if (productosagregados.length === existe) {
        console.log("iguales");
        existe = 0;
      }
    }
  };

  useEffect(() => {
    const calculateTotal = productosagregadosver.reduce((acc, producto) => {
      const preciot =
        parseFloat(producto.seriales.length) * parseFloat(producto.precio);
      const totalp = parseFloat(
        preciot + (preciot * producto.impuesto) / 100
      ).toFixed(2);
      return acc + parseFloat(totalp);
    }, 0);

    setTotal(calculateTotal);
  }, [productosagregadosver]);

  const processFile = async (file) => {
    try {
      const text = await file.text();
      const serialNumbers = text
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0);

      setLoading(true);
      const directus = await getDirectusClient();

      // Fetch serials that exist and are available (estado: 1)
      const serialsResponse = await directus.request(
        readItems("seriales", {
          fields: ["*", "producto.*", "producto.grupo.*"],
          filter: {
            _and: [
              {
                serial: { _in: serialNumbers },
              },
              {
                estado: { _eq: 1 },
              },
            ],
          },
        })
      );

      if (!serialsResponse || serialsResponse.length === 0) {
        Modal.error({
          title: "Seriales no encontrados",
          content: "No se encontraron seriales válidos en el archivo",
        });
        return;
      }

      // Check for invalid serials
      const foundSerials = new Set(serialsResponse.map((s) => s.serial));
      const invalidSerials = serialNumbers.filter(
        (serial) => !foundSerials.has(serial)
      );

      if (invalidSerials.length > 0) {
        Modal.warning({
          title: "Seriales inválidos o no disponibles",
          content: `Los siguientes seriales no están disponibles: ${invalidSerials.join(
            ", "
          )}`,
        });
      }

      // Process valid serials
      const nuevosSeriales = serialsResponse.map((serial) => ({
        ...serial,
        prestamo: "+",
      }));

      // Update state and arrays
      setProductosagregados((prev) => [...prev, ...nuevosSeriales]);

      Modal.success({
        title: "Seriales cargados",
        content: `Se cargaron ${serialsResponse.length} seriales correctamente`,
      });
    } catch (error) {
      console.error("Error processing file:", error);
      Modal.error({
        title: "Error",
        content: "Error al procesar el archivo de seriales",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Layouts>
      <Title level={4}>Crear prestamo rutas</Title>
      <Form
        form={form}
        layout="vertical"
        onFinish={onFinish}
        autoComplete="off"
      >
        <Form.Item
          name="vendedor"
          label="Vendedor"
          rules={[{ required: true }]}
        >
          <Select
            placeholder="Selecciona un vendedor"
            showSearch={true}
            filterOption={false}
            onSearch={handleSearch}
            onChange={selecionado}
            style={{ width: "300px" }} // Increased width for better visibility
          >
            {vendedoresloan.map((vendedor) => (
              <Option key={vendedor.id} value={vendedor.id}>
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span>
                    {vendedor.first_name} {vendedor.last_name}
                  </span>
                  {vendedor.tope_de_prestamo > 0 && (
                    <span style={{ color: "#52c41a" }}>
                      Tope: ${vendedor.tope_de_prestamo}
                    </span>
                  )}
                </div>
              </Option>
            ))}
          </Select>
        </Form.Item>
        {vendedorselect.id ? (
          <>
            {" "}
            <Space size={"large"}>
              Maximo de prestamo: {vendedorselect.tope_de_prestamo}
              <span style={{ color: "red" }}>
                {"      "}
                Prestamo usado: {vendedorselect.prestamo_usado}
              </span>
              <span style={{ color: "green" }}>
                Disponible:{" "}
                {vendedorselect.tope_de_prestamo -
                  vendedorselect.prestamo_usado}{" "}
              </span>
            </Space>
          </>
        ) : null}
        <Table
          columns={[
            { 
              title: "Producto", 
              dataIndex: "producto" 
            },
            { 
              title: "Cantidad", 
              dataIndex: "seriales",
              render: (seriales) => seriales?.length || 0
            },
            { 
              title: "Precio unitario", 
              dataIndex: "precio",
              render: (precio) => `$${precio?.toLocaleString() || 0}`
            },
            { 
              title: "Impuesto", 
              dataIndex: "impuesto",
              render: (impuesto) => `${impuesto || 0}%` 
            },
            { 
              title: "Total parcial", 
              key: "totalparcial",
              render: (_, record) => {
                const cantidad = record.seriales?.length || 0;
                const precio = record.precio || 0;
                const impuesto = record.impuesto || 0;
                
                // Calcular subtotal (precio * cantidad)
                const subtotal = precio * cantidad;
                
                // Calcular el valor del impuesto
                const valorImpuesto = subtotal * (impuesto / 100);
                
                // Calcular total (subtotal + impuesto)
                const total = subtotal + valorImpuesto;
                
                return `$${total.toLocaleString()}`;
              }
            },
            {
              title: "Action",
              key: "action",
              render: (_, record) => (
                <Space size="middle">
                  <Button
                    onClick={() => {
                      setSerialeslist(record.seriales);
                      setModalseriales(true);
                    }}
                    icon={<EyeOutlined />}
                    type="primary"
                  >
                    Ver seriales
                  </Button>
                  <Button
                    onClick={() => {
                      Modal.confirm({
                        title: "¿Quieres eliminar este producto?",
                        content: `Se eliminarán ${record.seriales.length} seriales asociados`,
                        onOk() {
                          // Create new array without the product to remove
                          const filteredProducts = arraytotalproductos.filter(
                            (item) => item.producto?.nombre !== record.producto
                          );

                          // Update array directly
                          arraytotalproductos.length = 0;
                          arraytotalproductos.push(...filteredProducts);

                          // Update state with empty array to force re-render
                          setProductosagregados([]);
                          setSerialeslist([]);

                          // Set delete flag
                          deletecambio = true;

                          // Force table update with new data
                          setProductosagregadosver(
                            Object.values(
                              filteredProducts.reduce((acc, obj) => {
                                const key = obj.producto?.nombre;
                                if (!acc[key]) {
                                  acc[key] = {
                                    producto: key,
                                    seriales: [],
                                    precio: obj.producto?.preciosinimp,
                                    impuesto: obj.producto?.grupo.impuesto,
                                    id: obj.producto?.id,
                                  };
                                }
                                acc[key].seriales.push({
                                  serial: obj.serial,
                                  id: obj.id,
                                });
                                return acc;
                              }, {})
                            )
                          );
                        },
                      });
                    }}
                    icon={<DeleteOutlined />}
                    type="primary"
                  >
                    Quitar producto
                  </Button>
                </Space>
              ),
            },
          ]}
          dataSource={productosagregadosver}
        ></Table>
        Total a prestar : {total}{" "}
        <span style={{ color: "red" }}>
          {parseFloat(total) >
          parseFloat(
            vendedorselect.tope_de_prestamo - vendedorselect.prestamo_usado
          )
            ? "Se excedió el limite de prestamo para el vendedor seleccionado"
            : console.log(
                parseFloat(
                  vendedorselect.tope_de_prestamo -
                    vendedorselect.prestamo_usado
                )
              )}
        </span>
        <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
          <Button
            disabled={
              parseFloat(total) >
              parseFloat(
                vendedorselect.tope_de_prestamo - vendedorselect.prestamo_usado
              )
                ? true
                : false
            }
            type="primary"
            htmlType="submit"
          >
            Crear prestamo
          </Button>
        </Form.Item>
      </Form>

      <h4>Añadir productos al prestamo</h4>
      <Space direction="vertical" style={{ width: "100%", marginBottom: 16 }}>
        <Tabs defaultActiveKey="1" items={items} onChange={onChange} />
        <Upload
          accept=".txt"
          beforeUpload={(file) => {
            processFile(file);
            return false;
          }}
          fileList={fileList}
          onChange={({ fileList }) => setFileList(fileList)}
        >
          <Button icon={<UploadOutlined />} loading={loading} type="primary">
            Cargar archivo de seriales
          </Button>
        </Upload>
      </Space>
      <Modal
        title="Seriales"
        onOk={() => {
          setSerialeslist([]);
          setModalseriales(false);
          deletecambio = false;
        }}
        onCancel={() => {
          setModalseriales(false);
          deletecambio = false;
        }}
        open={modalseriales}
      >
        {serialeslist.map((serial) => {
          return (
            <Space size={"small"}>
              {" "}
              <span>{serial.serial}</span>
              <Button
                onClick={() => {
                  console.log("eliminar serial " + serial.serial);
                  console.log(productosagregados);

                  Modal.confirm({
                    title: "Quieres eliminar serial " + serial.serial,
                    onOk() {
                      let nuevosseriales = productosagregados.filter(
                        (item) => item.serial !== serial.serial
                      );

                      let arran = arraytotalproductos.filter(
                        (item) => item.serial !== serial.serial
                      );

                      arraytotalproductos.splice(0, arraytotalproductos.length);

                      arran.map((a) => {
                        arraytotalproductos.push(a);
                      });

                      let lisserrialnew = serialeslist.filter(
                        (item) => item.serial !== serial.serial
                      );

                      setSerialeslist(lisserrialnew);

                      console.log(productosagregados.length);

                      setProductosagregados(nuevosseriales);
                      deletecambio = true;
                    },
                    onCancel() {
                      console.log("cancelar");
                    },
                  });
                }}
              >
                Eliminar
              </Button>
            </Space>
          );
        })}
      </Modal>
    </Layouts>
  );
}

export default LoanCreate;
